//
// Copyright 2024 DXOS.org
//
/** Wire literal for {@link ErrorProtocolMessage}. */
export const MESSAGE_TYPE_ERROR = 'error';
// ─── Subduction transport / control protocol ──────────────────────────────────
// Frames produced and consumed by `@automerge/automerge-repo`'s subduction
// transport bridge (`NetworkAdapterTransport`) plus the DXOS-side envelope
// and reconnect marker. Carried by the Edge subduction channel
// (`EdgeService.SUBDUCTION_REPLICATOR`) and the in-memory subduction adapter.
/** Wire literal for {@link SubductionConnectionMessage}. */
export const MESSAGE_TYPE_SUBDUCTION_CONNECTION = 'subduction-connection';
/** Wire literal for {@link SubductionFrameEnvelope}. */
export const MESSAGE_TYPE_SUBDUCTION_FRAME = 'subduction-frame';
/** Wire literal for {@link SubductionBatchEnvelope}. */
export const MESSAGE_TYPE_SUBDUCTION_BATCH = 'subduction-batch';
// ─── DXOS collection sync protocol ────────────────────────────────────────────
// DXOS extension on top of the automerge-repo Message type, used by
// `CollectionSynchronizer` to negotiate per-collection sync state. Carried
// by both the classical and subduction channels.
/** Wire literal for {@link CollectionQueryMessage}. */
export const MESSAGE_TYPE_COLLECTION_QUERY = 'collection-query';
/** Wire literal for {@link CollectionStateMessage}. */
export const MESSAGE_TYPE_COLLECTION_STATE = 'collection-state';
//# sourceMappingURL=automerge.js.map